import { Injectable } from '@angular/core';
import {
  FullscriptEmbedSessionRequest,
  FullscriptEmbedSessionResponse,
  FullscriptPatientLinkRequest,
  FullscriptStatus,
} from '@models';
import { map, Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { FullscriptService } from './fullscript.service';

@Injectable({ providedIn: 'root' })
export class FullscriptApiService
  extends HttpService<never>
  implements FullscriptService
{
  protected override readonly collectionPath = '/integrations/fullscript';

  getStatus(): Observable<FullscriptStatus> {
    return this.http.get<FullscriptStatus>(`${this.apiUrl}/status`);
  }

  getOAuthStartUrl(returnTo: string): Observable<string> {
    return this.http
      .get<{ url: string }>(`${this.apiUrl}/oauth/start`, {
        params: { returnTo },
      })
      .pipe(map(r => r.url));
  }

  getEmbedSession(
    req: FullscriptEmbedSessionRequest
  ): Observable<FullscriptEmbedSessionResponse> {
    return this.http.post<FullscriptEmbedSessionResponse>(
      `${this.apiUrl}/embed/session`,
      req
    );
  }

  linkPatient(req: FullscriptPatientLinkRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/patient-link`, req);
  }
}
